import Api from '../api';
let uri = "/api/ed/params";

export const paramService = { param };

function param(data) {
  return Api.getInstance().executeQuery(
    uri,
    {
      codigo: data.codigo,
      grupo: data.grupo,
      componente: data.componente,
      files: data.files,
    },
    { cache: true }
  );
}

export const getParametros = (data) => {
    return Api.getInstance().executeQuery(uri, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const updateParametro = (data)  => {
    return Api.getInstance().executeUpdateQuery(uri, data)
    .then(res => res)
    .catch(err => console.log(err));
}

